import { UtmLeadProductType } from '@enums/UtmLeadProduct'

export const autoVasConfig = {
  prod: {
    appGeneratorLink: 'https://tinyurl.internal.live.acko.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2W',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEM_FASTAG]: 'E4ieWcLIJTEZ8S',
      [UtmLeadProductType.PMAX_FASTAG]: 'P9XeQaLGJTEZ8S',
      [UtmLeadProductType.BRANDFORMANCE_FASTAG]: 'B3TeRcMGJTEZ8S',
      [UtmLeadProductType.META_FASTAG]: 'M1ZeKdNGJTEZ8S',
      [UtmLeadProductType.SEM_HSRP]: 'F3izWcMLOTEN0K',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5A',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4F',
    apiHsrpKeyWithoutUtm: 'P6cpWxTFBTEZ5H',
  },
  master: {
    appGeneratorLink: 'https://tinyurl.internal.ackodev.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2A',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c10eWSLKfTEZ3x',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEO_CHALLAN]: 's7imWcVPATEZ5B',
      [UtmLeadProductType.SEM_FASTAG]: 'f7ieWcLBKTEZ6F',
      [UtmLeadProductType.PMAX_FASTAG]: 'p9XeQaLBGTEZ6F',
      [UtmLeadProductType.BRANDFORMANCE_FASTAG]: 'b3TeRcMBLTEZ6F',
      [UtmLeadProductType.META_FASTAG]: 'm1ZeKdNBKTEZ6F',
      [UtmLeadProductType.SEM_HSRP]: 'B2izWcCDLTEN5T',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5B',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4C',
    apiHsrpKeyWithoutUtm: 'F2cpWxTFBTEZYK',
  },
  dev: {
    appGeneratorLink: 'https://tinyurl.internal.ackodev.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2A',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c10eWSLKfTEZ3x',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEM_FASTAG]: 'f7ieWcLBKTEZ6F',
      [UtmLeadProductType.PMAX_FASTAG]: 'p9XeQaLBGTEZ6F',
      [UtmLeadProductType.BRANDFORMANCE_FASTAG]: 'b3TeRcMBLTEZ6F',
      [UtmLeadProductType.META_FASTAG]: 'm1ZeKdNBKTEZ6F',
      [UtmLeadProductType.SEM_HSRP]: 'B2izWcCDLTEN5T',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5B',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4C',
    apiHsrpKeyWithoutUtm: 'F2cpWxTFBTEZYK',
  },
  local: {
    appGeneratorLink: 'https://tinyurl.internal.ackodev.com/api/v1/appflyer_deep_link/',
    apiKeySem: {
      [UtmLeadProductType.SEM_CHALLAN]: 'c1imWcVFVTEW2W',
      [UtmLeadProductType.PMAX_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.META_CHALLAN]: 'c19eWSqWfTEZ3y',
      [UtmLeadProductType.SEM_FASTAG]: 'E4ieWcLIJTEZ8S',
      [UtmLeadProductType.PMAX_FASTAG]: 'P9XeQaLGJTEZ8S',
      [UtmLeadProductType.BRANDFORMANCE_FASTAG]: 'B3TeRcMGJTEZ8S',
      [UtmLeadProductType.META_FASTAG]: 'M1ZeKdNGJTEZ8S',
      [UtmLeadProductType.SEM_HSRP]: 'F3izWcMLOTEN0K',
    },
    apiChallanKeyWithouUtm: 's7imWcVPATEZ5B',
    apiFastagKeyWithoutUtm: 'f4imWcFNATEZ4C',
    apiHsrpKeyWithoutUtm: 'P6cpWxTFBTEZ5H',
  },
}
